import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    // Also try scrolling document element and body
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }
  };

  // Scroll to top on mount (when page loads/reloads)
  useEffect(() => {
    // Immediate scroll
    scrollToTop();
    
    // Use requestAnimationFrame to ensure scroll happens after layout is complete
    requestAnimationFrame(() => {
      scrollToTop();
      requestAnimationFrame(() => {
        scrollToTop();
        // One more time after a short delay to handle browser restore scroll position
        setTimeout(() => {
          scrollToTop();
        }, 100);
      });
    });
  }, []);

  // Scroll to top when pathname changes
  useEffect(() => {
    // Use requestAnimationFrame to ensure scroll happens after layout is complete
    requestAnimationFrame(() => {
      scrollToTop();
      requestAnimationFrame(() => {
        scrollToTop();
      });
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
